<template>
  <div>
    <body>
      <section class="wrapper">
        <!-- <header class="casestudies">
          <router-link to="/">
            <div class="logo">
              <a href="index.html">翰林永續創意教案</a>
            </div>
          </router-link>
        </header> -->
        <section class="cases-main m_10em" v-if="plan !== undefined">
          <div class="share-box">
            <ul class="share-itme l_float">
              <li>
                <a
                  :href="'https://repo.hle.com.tw/plans/' + plan.id + '.7z'"
                  target="_blank"
                >
                  <li class="bk"><span class="share-01"></span></li
                ></a>
              </li>
              <li @click="shareOnFacebook()">
                <span class="share-02">facebook</span>
              </li>
              <li @click="shareOnLine()"><span class="share-03">line</span></li>
            </ul>
            <ul class="share-itme r_float">
              <li><span class="share-04">翰林出版</span></li>
              <li><span class="share-05">天下雜誌</span></li>
            </ul>
          </div>
          <h3 class="clearfix">
            {{ plan.name }}
          </h3>

          <div class="intro_box">
            <ul class="l_float w_40">
              <li><span>適合階段：</span>{{ plan.grade }}</li>
              <li><span> 年度：</span>{{ plan.year }}</li>
              <li><span> 獎項：</span>{{ plan.awardName }}</li>
              <li><span> 地區：</span>{{ plan.city }}</li>
            </ul>
            <ul>
              <li><span>科目：</span>{{ plan.subject }}</li>
              <li><span>教師：</span>{{ plan.teacher }}</li>
              <li><span>學校：</span>{{ plan.school }}</li>
            </ul>
          </div>

          <div v-if="!plan.validYoutubeLink" class="video-shadow">
            <div v-if="plan.id <= this.plansData.planItems.length">
              <img
                v-if="plan.imgFileExists"
                width="1280"
                height="717"
                :src="require(`@/images/${plan.id}.png`)"
              />
              <img v-else src="@/images/img_default.png" />
            </div>
            <div v-if="plan.id > this.plansData.planItems.length">
              <iframe
                width="1280"
                height="717"
                src="https://www.youtube.com/embed/TSXXi2kvl_0"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>

          <div v-if="plan.validYoutubeLink" class="video-shadow">
            <iframe
              width="1280"
              height="717"
              :src="'https://www.youtube.com/embed/' + plan.youtubeLink"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>

          <div class="intro_text">
            <p v-html="plan.summary"></p>
          </div>
        </section>
        <!-- <footer class="clearfix">
          <p>
            為獲得最佳瀏覽體驗，建議使用Edge、Chrome、Firefox，如使用IE部份網頁可能會有破圖、跑版或功能無法正確顯示及使用。
          </p>
          <p>Copyright © 2021 Hanlin 翰林出版事業股份有限公司</p>
        </footer> -->
      </section>
      <div class="topup" @click="scrollToTop()"></div>
    </body>
  </div>
</template>

<script>
import { useDataContext } from "@/composable/plans";

export default {
  name: "PlanComponent",

  setup() {
    return useDataContext();
  },
  data() {
    return {
      planID: this.$route.params.id,

      planItemsLength: this.plansData.planItems.length,
    };
  },

  computed: {
    plan() {
      let rawPlan = this.plansData.planLookupTable[this.planID];
      if (
        rawPlan === undefined &&
        this.plansData.planItems.length > 0 &&
        this.planID > this.plansData.planItems.length
      ) {
        return {
          id: this.planID,
          year: "",
          awardName: "",
          name: this.planID + "教案不存在",
          subject: "",
          grade: "",
          city: "",
          school: "",
          teacher: "",
          downloadLink: "",
          youtubeLink: "",
          imageLink: "",
          summary: "",
        };
      }
      return rawPlan;
    },
  },
  created() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    shareOnFacebook() {
      var id = this.planID;
      let facebookWindow = window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" +
          "https://lessonplan.hle.com.tw/lessonPlanHtml/" +
          id +
          ".html",

        "facebook-popup"
      );

      if (facebookWindow.focus) {
        facebookWindow.focus();
      }
      return false;
    },
    shareOnLine() {
      var id = this.planID;
      let lineWindow = window.open(
        "http://line.me/R/msg/text/?" +
          "https://lessonplan.hle.com.tw/lessonPlanHtml/" +
          id +
          ".html",
        "facebook-popup"
      );

      if (lineWindow.focus) {
        lineWindow.focus();
      }
      return false;
    },
    download() {
      return this.plansData.planLookupTable[this.planID].downloadLink;
    },
  },
};
</script>

<style scoped></style>
